import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Styles from "./css/footerlinkssingle.module.scss";
import { isChrome, isFirefox, isIeEdge, getBrowser } from "@tightrope/lpscripts/browserdetect";

var FooterlinksSingle = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FooterlinksSingle, _React$Component);

  function FooterlinksSingle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      display: "block",
      unsubscribe: false
    };

    if (props.data) {
      _this.state.data = props.data;
    }

    if (props.unsubscribe) {
      _this.setState({
        unsubscribe: props.unsubscribe
      });
    }

    return _this;
  }

  var _proto = FooterlinksSingle.prototype;

  _proto.showBrowsers = function showBrowsers(browsers) {
    var display = false;

    if (getBrowser() === 'ie' && browsers.includes('ie')) {
      display = true;
    }

    if (getBrowser() === 'firefox' && browsers.includes('firefox')) {
      display = true;
    }

    if (getBrowser() === 'chrome' && browsers.includes('chrome')) {
      display = true;
    }

    if (getBrowser() === 'edge' && browsers.includes('edge')) {
      display = true;
    }

    if (getBrowser() === 'other' && browsers.includes('other')) {
      display = true;
    }

    if (display) this.setState({
      display: 'block'
    });else this.setState({
      display: 'none'
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.browsers) {
      this.showBrowsers(this.props.browsers);
    } else {
      this.setState({
        display: 'block'
      });
    }
  };

  _proto.render = function render() {
    var unsubscribe = null;

    if (this.state.unsubscribe) {
      unsubscribe = /*#__PURE__*/React.createElement("span", null, " | ", /*#__PURE__*/React.createElement("a", {
        href: "/unsubscribe/",
        target: "_blank"
      }, "Unsubscribe"));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: Styles.br,
      style: {
        display: this.state.display
      }
    }, "Tightrope Interactive | ", /*#__PURE__*/React.createElement("a", {
      href: "/terms-of-service/",
      target: "_blank"
    }, "Terms"), " | ", /*#__PURE__*/React.createElement("a", {
      href: "/privacy-policy/",
      target: "_blank"
    }, "Privacy"), " | ", /*#__PURE__*/React.createElement("a", {
      href: "/uninstall/",
      target: "_blank"
    }, "Uninstall"), " ", unsubscribe, " | ", /*#__PURE__*/React.createElement("a", {
      href: "/contact-us/",
      target: "_blank"
    }, "Contact"), " ", /*#__PURE__*/React.createElement("br", null), "All trademarks are property of their respective owners | ", /*#__PURE__*/React.createElement("a", {
      href: "/privacy-policy/#cali-consumer",
      target: "_blank"
    }, "Do Not Sell My Personal Information"));
  };

  return FooterlinksSingle;
}(React.Component);

export default FooterlinksSingle;